import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'app/hooks';
import { SiteStateProps } from 'features/site/siteSlice';
import { RootState } from '../app/store';

// Extended type that includes site properties and status
export type SiteWithStateProps = SiteStateProps & {
  status: 'idle' | 'loading' | 'failed';
  errors: any;
};

export const useSite = (): SiteWithStateProps => {
  const siteState = useAppSelector(
    (state: RootState) => state.site,
    shallowEqual,
  );

  return useMemo(
    () => ({
      users: siteState.users,
      menus: siteState.menus,
      pages: siteState.pages,
      projects: siteState.projects,
      publications: siteState.publications,
      members: siteState.members,
      library: siteState.library,
      fetchStatus: siteState.fetchStatus,
      status: siteState.status,
      errors: siteState.errors,
    }),
    [
      siteState.users,
      siteState.menus,
      siteState.pages,
      siteState.projects,
      siteState.publications,
      siteState.members,
      siteState.library,
      siteState.fetchStatus,
      siteState.status,
      siteState.errors,
    ],
  );
};
